import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Badge, } from 'antd';
import { truncateText } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { PlusIcon } from '../../utils/icons';
import Female06 from "../../assets/images/Female06.png";
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { setMessageDetailsReducer } from '../../slices/userSlice';
import { getS3Media } from '../../services/awsServices';

const UserInUserList = ({ items, type, onClick=()=>{}, }) => {
  const dispatch = useDispatch()
  // const userList = useSelector((state) => state.user.userList) || [];
  const connectedUser = useSelector((state) => state.user.connectedUser) || [];
  const userAttributes = useSelector((state) => state.user.userAttributes) || {};
  const newMsgDetailObj = useSelector((state) => state.user.newMsgDetailObj) || {};
  const selectedUser = useSelector((state) => state.user.selectedUserOrChannel) || {};
  const newMsgDetailObjRef = useRef(newMsgDetailObj);
  const [dp, setDp] = useState();

  // console.log(selectedUser, " ====selectedUserOrChannel");
  // useEffect(()=>{
  //   if(selectedUser.PK.S === items?.PK?.S){

  //   }
  // }, [])

  console.log(newMsgDetailObj, "++====newMsgDetailObj++==");

  useEffect(() => {
    newMsgDetailObjRef.current = newMsgDetailObj;
  }, [newMsgDetailObj]);

  const profilePicture = items?.Documents?.ProfilePicture;

  console.log({ profilePicture });
  
  const fetchImage = async () => {
    const res = await getS3Media(profilePicture);
    console.log(res, "dataurllllllllll:userinuserlist");
    setDp(res?.data?.url);
  };

  useEffect(() => {
    if(profilePicture){
      fetchImage();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // console.log(selectedUser?.PK?.S, " === ", newMsgDetailObjRef.current[selectedUser?.PK?.S], "setInterval", newMsgDetailObjRef.current);
      if (selectedUser?.PK && newMsgDetailObjRef.current[selectedUser?.PK]) {
        console.log("set timeout");
        dispatch(setMessageDetailsReducer({ userId: selectedUser.PK, isRemove: true }));
      } 
    }, 30000);

    return () => clearInterval(intervalId);
  }, [selectedUser?.PK, dispatch]);

  const NamChar = items && items?.Name?.charAt(0);
  const DisplayName = truncateText(items?.Name, 10) + (type ? ` (${type})`: ``);

  return (
    <div className={`flex items-center justify-between cursor-pointer p-2 border-b-[1px] shadow-md rounded-lg mb-1 border-gray-300 ${selectedUser?.PK === items?.PK ? "bg-gradient-to-tr from-orange1 to-redOrange text-pureWhite": ""}`} onClick={onClick}>
      <div className="flex items-center gap-2">
          <Badge dot offset={[0, 10]} color={connectedUser?.includes(items?.PK) ? "green" : "gray"}>
          <Avatar src={dp} alt={"Avatar"}>
            {NamChar}
          </Avatar>
          </Badge>
        <div>
          <CustomTooltip title={items?.PK?.includes(userAttributes?.sub) ? `${truncateText(items?.Name, 7)} (You)` : items?.Name}>
              <h1 className="text-base font-semibold no-break">
              {items?.PK?.includes(userAttributes?.sub)
                  ? `${truncateText(items?.Name, 7)} (You)`
                  : DisplayName}
              </h1>
          </CustomTooltip>
          {/* <p className="text-xs">{items.msg}</p> */}
        </div>
      </div>

      <div className="flex flex-col items-end">
          {newMsgDetailObj[items.PK] > 0 ? (
          <div className={`rounded-full w-[20px] h-[20px] text-[10px] font-bold flex justify-center items-center ${selectedUser?.PK === items?.PK ? "text-[#FF6B38] bg-pureWhite": "text-pureWhite bg-orange-600"}`}>
              {newMsgDetailObj[items.PK]}
          </div>
          ) : (
          // <p className="text-sm">10:45</p>
          <></>
          )}
      </div>
    </div>
  )
}

export default UserInUserList;


{/* {items.tag ? (
  <Tag className="bg-orange2 text-white m-0 px-1 font-semibold">
      {items.tag}
  </Tag>
  ) : items.tick ? (
  items.tick
  ) : items.doubleTick ? (
  items.doubleTick
  ) : null} */}